/**
 * Shared time utilities for worksheet / sweep timer logic.
 * Both AiAnswerSheetUpload and WorkSheetTake previously duplicated these.
 */

/**
 * Parse a duration value into seconds.
 * Accepts: number, numeric string, "MM:SS", "HH:MM:SS".
 * Returns 0 for null / undefined / invalid. Falls back to defaultSec when result is 0.
 */
export function parseDurationSec(val, defaultSec = 0) {
  if (val === null || val === undefined || val === "") return defaultSec;
  if (typeof val === "number") return Number.isFinite(val) && val > 0 ? val : defaultSec;
  if (typeof val === "string") {
    const trimmed = val.trim();
    if (!trimmed) return defaultSec;
    const numeric = Number(trimmed);
    if (Number.isFinite(numeric)) return numeric > 0 ? numeric : defaultSec;
    const parts = trimmed.split(":").map(Number);
    if (parts.some(Number.isNaN)) return defaultSec;
    if (parts.length === 2) return parts[0] * 60 + parts[1];
    if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
  }
  return defaultSec;
}

/**
 * Format seconds into "M:SS" display string.
 */
export function formatTime(seconds) {
  const s = Math.max(0, Math.min(86400, Math.floor(Number(seconds) || 0)));
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${m}:${String(sec).padStart(2, "0")}`;
}
